<template>
  <article
    class="catalog-item"
    v-bind:ref="refName"
    itemscope
    itemtype="http://schema.org/Product"
  >
    <router-link
      title="Подробнее..."
      v-bind:to="getRoute(jewel)"
    >
      <vignette
        v-bind:vignette-size="parseInt(jewel.preview_image_vignette_size)"
        v-bind:vignette-blur="parseInt(jewel.preview_image_vignette_blur)"
        v-bind:vignette-color="cardBackgroundColor"
        v-bind:border-radius="parseInt(jewel.preview_image_border_radius)"
      >
        <img
          v-lazy="jewel.preview_image"
          v-bind:alt="metaDescription"
          width="500px"
          height="500px"
          itemprop="image"
        >
      </vignette>
      <meta itemprop="description" v-bind:content="metaDescription">
      <catalog-jewel-card-description
        v-bind:jewel="jewel"
      ></catalog-jewel-card-description>
    </router-link>
  </article>
</template>

<script>
import Vignette from './utils/Vignette'
import CatalogJewelCardDescription
  from './catalog-jewel-card/CatalogJewelCardDescription'

export default {
  name: 'CatalogJewelCard',
  components: { Vignette, CatalogJewelCardDescription },
  props: ['jewel'],
  data () {
    return {
      refName: '',
      cardBackgroundColor: ''
    }
  },
  computed: {
    metaDescription: function () {
      const title = this.jewel.title
      const price = this.jewel.price
      const code = this.jewel.vendor_code ? this.jewel.vendor_code : this.jewel.note
      return (price > 0)
        ? `${title} ${code} от ювелирной фирмы "Стиль" по цене ${price} руб.`
        : `${title} ${code} от ювелирной фирмы "Стиль"`
    }
  },
  mounted () {
    this.refName = `${this.jewel.vendor_code_alias}-card`
    this.$nextTick(this.updateCardBackgroundColor)
  },
  methods: {
    getRoute: function (jewel) {
      const params = Object.assign(
        { jewel: jewel.vendor_code_alias },
        this.$route.params
      )
      return {
        name: 'CatalogJewelPage',
        params: params
      }
    },
    updateCardBackgroundColor: function () {
      const styles = getComputedStyle(this.$refs[this.refName])
      this.cardBackgroundColor = styles['background-color']
    }
  }
}
</script>

<style scoped lang="scss">
  $item-margin: 1%;
  $item-margin-mobile: 5%;

  @function calc-item-width ($n-columns, $item-margin) {
    @return ((100% - 2 * $item-margin * $n-columns) / $n-columns);
  }
  @mixin item-flex-width($n-columns: 4, $margin: $item-margin) {
    max-width: calc-item-width($n-columns, $margin);
    flex-basis: calc-item-width($n-columns, $margin);
  }

  .catalog-item {
    background-color: $content-background-color;
    box-sizing: border-box;
    padding: 2%;
    margin: $item-margin;
    flex-grow: 1;

    transition: transform 0.3s ease;
    @media (hover: hover) {
      &:hover {
        transform: scale(1.03);
      }
    }

    @include media (">desktop") {
      @include item-flex-width($n-columns: 4);
    };
    @include media (">tablet", "<=desktop") {
      @include item-flex-width($n-columns: 3);
    };
    @include media (">mobile", "<=tablet") {
      @include item-flex-width($n-columns: 2);
    };
    @include media ("<=mobile") {
      @include item-flex-width($n-columns: 1, $margin: $item-margin-mobile);
      margin: 0 $item-margin-mobile $item-margin-mobile $item-margin-mobile;
      padding: $item-margin-mobile;
      &:first-child { margin-top: $item-margin-mobile; }
    };
    @media only print {
      display: block;
      max-width: none;
      padding: 0;
      margin: 0;
      page-break-inside: avoid;
    }

    & > a {
      text-decoration: none;
      font-family: $font-stack;
      color: $default-text-color;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      @media only print {
        display: block;
        overflow: auto;
        padding-bottom: 1cm;
        text-align: left;
        &:after {
          padding-top: 0.5cm;
          display: block;
          margin-left: 50%;
        }

        & >>> .image-with-vignette {
          float: left;
          margin-left: 15%;
          width: 30%;
          @media (orientation: landscape) { width: 25%; }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/CatalogJewelCard.vue